import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadBillOfMaterialCode = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadBillOfMaterialList = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadBillOfMaterialMOList = async (payload) => {
    try {
        // const payload = {
        //     p_companyid: localStorage.getItem('companyid') || 0,
        //     p_plantid: 1,
        //     p_productvariety_id:p_productvariety_id
        // };

        return await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_MO_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadBillOfMaterialListSummary = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.BILL_MATERIAL_GET_LIST_SUMMARY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const billOfMaterialPlanCRUD = async (api, payload) => {
    try {       
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

